import { FC } from 'react';

import { TaxResidency } from '__generated__/GQL';
import useCountriesList from 'common/countries/useCountriesList';
import InformationSection from 'features/Onboarding/components/InformationSection';
import { formatComplianceInformationItems } from 'features/Onboarding/helpers/formatComplianceInformationItems';
import { FiscalSituationSchema } from 'features/Onboarding/modules/Compliance/pages/ComplianceForm/components/Form';

import locales from './locales';

interface FiscalInformationProps {
  complianceValues: Partial<FiscalSituationSchema>;
  taxResidencies: Pick<TaxResidency, 'country' | 'fiscalId'>[];
  onEdit?: () => void;
}
export type FiscalInformationType = FC<FiscalInformationProps>;

const FiscalInformation: FiscalInformationType = ({
  complianceValues,
  onEdit,
  taxResidencies,
}) => {
  const countriesOptions = useCountriesList();

  const { complianceInformationItems, secondaryComplianceInformationItems } =
    formatComplianceInformationItems(
      complianceValues,
      taxResidencies,
      countriesOptions,
    );

  return (
    <InformationSection
      iconName="euro"
      items={complianceInformationItems}
      onEdit={onEdit}
      secondaryItems={secondaryComplianceInformationItems}
      title={locales.section}
    />
  );
};

export default FiscalInformation;
